export var name = "@atlaskit/editor-core";
export var version = "193.7.0";